/**
 * @file Filter out parts of a product name
 *
 * @author Torbjørn Høvde
 * @version 1
 */
const concepts = ['norrøna', 'Norrøna', 'baselayer', '/29', 'oslo', 'røldal', 'tamok', 'lofoten', 'lyngen', 'trollveggen', 'falketind', 'unstad', 'skibotn', 'fjørå', 'bitihorn', 'svalbard', 'kvinnherad', 'finnskogen', 'dovre', 'recon', 'wool ', 'equaliser merino', 'arktis', 'senja'];
const sex = ['(M/W)', '(M)', '(W)', 'M\'s', 'W\'s', 'Unisex', 'M´s', 'Jr´s', 'W´s'];
const type = ['Hood Jacket', 'Jacket', 'Pants', 'Zip Hoodie', 'Hoodie', 'short Gloves', 'short Mittens', 'Gloves', 'Mittens', 'Shorts', 'Socks long', 'Socks', 'Spare Lens', 'One-piece'];

function removeFromList (str, arr) {
  return arr.reduce((result, word) => result.replace(word, ''), str);
}
function findFromList (str, arr) {
  let temp;
  let finding = ' ';
  for (let i = 0; i < arr.length; i++) {
    temp = str.replace(arr[i], '');
    if (temp !== str) {
      finding = arr[i];
      break;
    }
  }
  return finding;
}

function superscriptName (name) {
  // const regex = /\b([a-z]+)(\d+)\b/i;
  // const match = name.match(regex);
  // if (match) {
  //   name = name.replace(match[0], `${match[1]}<sup>${match[2]}</sup>`);
  // }
  return name;
}

export const productFabricFilter = (name) => {
  name = removeFromList(name, concepts);
  name = removeFromList(name, sex);
  name = removeFromList(name, type);
  // console.log(`|${name.trim()}|`, `|${name}|`, name === name.trim());
  return name.trim();
};
export const productTypeFilter = (name) => {
  return findFromList(name, type);
};

export function productNameSpan (concept, name, gender, boldConcept = true) {
  let str = `<span${boldConcept ? ' class="-bold" ' : ''}>${concept}</span>&nbsp;`;
  str += `<span${boldConcept ? ' class="-light" ' : ''}>${superscriptName(name)}`;
  gender = gender ? gender.replace('Male', 'men').replace('Female', 'women') : '';
  if (gender && ['men', 'women'].includes(gender)) {
    str += '&nbsp;' + gender[0].toUpperCase() + "'s";
  }

  str += '</span>';
  return str;
}

export const removeSex = (name) => {
  name = removeFromList(name, sex);
  return name.trim();
};
